module.exports = __webpack_public_path__ + "img/product-bg.8064248.webp";